import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";
import IconButton from "@mui/material/IconButton";
import { CustomLink } from "core/components/CustomLink";
import { pickHighlight, renderHighlight } from "core/components/HighlightText";
import { useFormatDate } from "core/hooks/useFormatDate";
import { MyLinksIcon } from "features/MyLinks/components/MyLinksIcon";
import { getMyLinksHref } from "features/MyLinks/utils";
import { useTranslation } from "react-i18next";
import type { SearchResultEvent } from "../defs";
import { SearchItemTemplate } from "./SearchItemTemplate";

export function SearchItemEvent(props: SearchResultEvent) {
  const { t } = useTranslation("Fixhub", { keyPrefix: "Next:Core:SearchItem" });
  const {
    title,
    blurb,
    isFavorited,
    dynamicData,
    highlights,
    aggregateRootId,
  } = props;
  const formatDate = useFormatDate();
  const { startDate: startDateRaw, endDate: endDateRaw } = dynamicData;
  const [startDate, endDate] = [
    formatDate(startDateRaw),
    formatDate(endDateRaw),
  ];
  return (
    <SearchItemTemplate
      data-testid="search-item-event"
      dateLabel={t("eventDateLabel")}
      dateText={t("eventDate", { startDate, endDate })}
      secondaryAction={
        <IconButton
          LinkComponent={CustomLink}
          disabled={!aggregateRootId}
          href={getMyLinksHref("Event", aggregateRootId)}
        >
          <KeyboardDoubleArrowRight color="primary" />
        </IconButton>
      }
      AvatarIcon={<MyLinksIcon itemType="Event" />}
      title={renderHighlight(title, pickHighlight(highlights, "String1"))}
      titleSecondary={renderHighlight(
        blurb,
        pickHighlight(highlights, "String5")
      )}
      isFavorited={isFavorited}
    />
  );
}
